<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3.5,9C5.433,9,7,10.567,7,12.5C7,14.433,5.433,16,3.5,16C1.567,16,0,14.433,0,12.5C0,10.567,1.567,9,3.5,9C3.5,9,3.5,9,3.5,9ZM13,10C14.6569,10,16,11.3431,16,13C16,14.6569,14.6569,16,13,16C11.3431,16,10,14.6569,10,13C10,11.3431,11.3431,10,13,10C13,10,13,10,13,10ZM3.5,11C2.67157,11,2,11.6716,2,12.5C2,13.3284,2.67157,14,3.5,14C4.32843,14,5,13.3284,5,12.5C5,11.6716,4.32843,11,3.5,11C3.5,11,3.5,11,3.5,11ZM13,12C12.4477,12,12,12.4477,12,13C12,13.5523,12.4477,14,13,14C13.5523,14,14,13.5523,14,13C14,12.4477,13.5523,12,13,12C13,12,13,12,13,12ZM5,0C6.4601,0,7.52741,0.668248,8.00074,2C8.00074,2,8.81547,5.25536,8.81547,5.25536C9.56258,5.31185,10.2921,5.3768,11.0012,5.45031C11.0012,5.45031,11,2,11,2C11,2,13,2,13,2C13,2,13.0012,5.68814,13.0012,5.68814C13.6989,5.78256,14.371,5.88648,15.014,6C15.6372,6.11001,16,6.47852,16,7C16,7,15.9998,10.3535,15.9998,10.3535C15.2669,9.52318,14.1946,8.99945,13,8.99945C11.1366,8.99945,9.57088,10.2737,9.12661,11.9983C9.12661,11.9983,7.99891,11.9989,7.99891,11.9989C7.99891,11.9989,7.97299,11.9975,7.97299,11.9975C7.72351,9.74863,5.81658,7.99973,3.50115,7.99973C2.42345,7.99973,1.43425,8.3786,0.65948,9.01042C0.65948,9.01042,0.00464454,9.01114,0.00464454,9.01114C0.00464454,9.01114,0.00409441,8.1825,0.00409441,8.1825C0.00351416,7.38636,0.00263399,6.4234,0.00148854,6.02249C-4.54747e-11,5.49942,0.376214,4.99008,1,4.99008C1,4.99008,1,1,1,1C1,0.447715,1.44772,1.01453e-16,2,0C2,0,5,0,5,0C5,0,5,0,5,0ZM6,2C6,2,3,2,3,2C3,2,3,4.99008,3,4.99008C4.29001,5.01426,5.55437,5.05897,6.7814,5.1246C6.7814,5.1246,6,2,6,2C6,2,6,2,6,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Tractor',
} as DefineComponent
</script>
